"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const preferencesSelectors = __importStar(require("companion-app-components/flux/preferences/selectors"));
const AccountList_1 = __importDefault(require("components/AccountList"));
const auth_1 = require("companion-app-components/flux/auth");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const selectors_1 = require("data/datasetSharing/selectors");
const actions_1 = require("data/AccountDiscovery/actions");
const components_1 = require("./components");
const styles_1 = require("./styles");
let userClickedOnCollapseButton = false;
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const AccountDrawer = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes, theme } = useStyles();
    const [drawerState, setDrawerState] = React.useState({
        drawerOpen: props.open,
        selectedAccountNodeId: props.selectedNode,
        currentRoute: null,
    });
    const datasetPreferences = (0, react_redux_1.useSelector)((state) => preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] }));
    const addFiEnabled = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = feature_flags_1.featureFlagsSelectors.getFeatureFlags(state)) === null || _a === void 0 ? void 0 : _a.get('addFi'); });
    const isWebFirstDataset = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getIsWebfirstDataset(state));
    const isCurrentDatasetOwner = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIsCurrentDatasetOwner)(state));
    const defaultInitiator = 'account list app';
    const dispatchDoAccountDiscovery = (initiator, directToManualAccounts = false) => dispatch((0, actions_1.doAccountDiscovery)({
        initiator: initiator || defaultInitiator,
        mode: directToManualAccounts ? 'ADD-FI-MANUAL' : 'ADD-FI',
    }));
    let widthBeforeResize = null;
    const prevSelectedNode = (0, react_use_1.usePrevious)(props.selectedNode);
    const prevDrawerOpen = (0, react_use_1.usePrevious)(props.open);
    const prevAccountDrawerDefaultOpen = (0, react_use_1.usePrevious)(props.accountDrawerDefaultOpen);
    const handleResize = () => {
        if (props.drawerChange) {
            const isWidthChanged = window.innerWidth !== widthBeforeResize;
            widthBeforeResize = null;
            if (!isWidthChanged) {
                return;
            }
            const updateStateFlag = (userClickedOnCollapseButton && window.innerWidth <= 800) || (!userClickedOnCollapseButton);
            if (updateStateFlag) {
                setDrawerState((prevState) => (Object.assign(Object.assign({}, prevState), { drawerOpen: window.innerWidth >= theme.mixins.accountDrawer.collapsePoint })));
            }
        }
    };
    const resizeThrottler = () => {
        let resizeTimeout = null;
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(handleResize, 66);
        if (widthBeforeResize === null) {
            widthBeforeResize = window.innerWidth;
        }
    };
    const handleDrawerToggle = (e) => {
        if (props.drawerChange) {
            e.stopPropagation();
            userClickedOnCollapseButton = drawerState.drawerOpen;
            setDrawerState((prevState) => (Object.assign(Object.assign({}, prevState), { drawerOpen: !drawerState.drawerOpen })));
            props.drawerChange(!drawerState.drawerOpen);
            const { longCats, wrapText } = datasetPreferences.transactionRegister;
            if (longCats || wrapText) {
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 500);
            }
        }
    };
    const handleAccountNodeSelect = (currentNode) => {
        var _a;
        let node = currentNode;
        // For Separate accounts the route can be transactions and have investment accounts inside
        if (node.routeTo === '/transactions' &&
            (((_a = node.account) === null || _a === void 0 ? void 0 : _a.type) === 'INVESTMENT' || node.id === 'BROKERAGE')) {
            node = node.set('routeTo', '/investments');
        }
        // if the user specified a handler, call the handler.
        // if it returns 'true' also execute the default action
        let doDefault = true;
        if (props.nodeSelect) {
            doDefault = props.nodeSelect(node);
        }
        if (doDefault && node.routeTo) {
            if (typeof node === 'string') {
                setDrawerState((prevState) => (Object.assign(Object.assign({}, prevState), { selectedAccountNodeId: node })));
                // if switching to a new page, do a 'push', otherwise switches on the same page do a 'replace'
            }
            else if (!drawerState.selectedAccountNodeId || (drawerState.currentRoute !== node.routeTo)) {
                props.router.navigate(`${node.routeTo}?displayNode=${node.id}`);
                setDrawerState((prevState) => (Object.assign(Object.assign({}, prevState), { currentRoute: node.routeTo })));
            }
            else {
                props.router.navigate(`${node.routeTo}?displayNode=${node.id}`, { replace: true });
                setDrawerState((prevState) => (Object.assign(Object.assign({}, prevState), { currentRoute: node.routeTo })));
            }
        }
    };
    const handleAddInstitutionLogin = (initiator, directToManualAccounts = false) => (event) => {
        if (addFiEnabled && isWebFirstDataset) {
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            dispatchDoAccountDiscovery(initiator, directToManualAccounts);
        }
    };
    React.useEffect(() => {
        if (props.drawerChange) {
            window.addEventListener('resize', resizeThrottler);
        }
        return () => {
            window.removeEventListener('resize', resizeThrottler);
            userClickedOnCollapseButton = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(() => {
        if (props.selectedNode !== prevSelectedNode) {
            setDrawerState((prevState) => (Object.assign(Object.assign({}, prevState), { selectedAccountNodeId: props.selectedNode })));
        }
        if (props.open !== prevDrawerOpen) {
            setDrawerState((prevState) => (Object.assign(Object.assign({}, prevState), { drawerOpen: props.open })));
        }
        // Sync the value of the preference if it is different from current state
        if (props.accountDrawerDefaultOpen !== prevAccountDrawerDefaultOpen &&
            props.accountDrawerDefaultOpen !== drawerState.drawerOpen) {
            if (props.drawerChange) {
                props.drawerChange(drawerState.drawerOpen);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedNode, props.open, props.accountDrawerDefaultOpen, prevSelectedNode, prevDrawerOpen, prevAccountDrawerDefaultOpen]);
    const balRef = React.useRef(null);
    const { transactionRegister: regPrefs, accountBarBalanceType, accountBarShowCents } = datasetPreferences;
    const showColors = regPrefs && regPrefs.showAccountColors && !props.suppressColorBars;
    // hardcode to 'available balance', or 'today'
    const balanceType = accountBarBalanceType;
    return (<>
      {props.drawerChange &&
            <div className={drawerState.drawerOpen ? classes.overlay : classes.overlayClosed} onClick={handleDrawerToggle} role="presentation"/>}
      <div ref={balRef} className={classes.container}>
        <div className={drawerState.drawerOpen ? classes.drawerPaper : classes.drawerPaperClosed}>
          <RendersCount_1.default id="accountDrawer"/>
          <Box_1.default id={`${props.prefix}qCard-add-account`} className={classes.drawerHeader} sx={Object.assign({}, (!drawerState.drawerOpen && { bgcolor: 'inherit' }))} onClick={() => props.router.navigate('/transactions?displayNode=all', { replace: true })} onKeyDown={lodash_1.noop}>
            <components_1.AccountListHeader classes={classes} handleAddInstitutionLogin={handleAddInstitutionLogin} addFiEnabled={addFiEnabled && isWebFirstDataset && isCurrentDatasetOwner}/>
            {props.drawerChange &&
            <components_1.AccountDrawerToggle open={drawerState.drawerOpen} classes={classes} handleDrawerToggle={handleDrawerToggle} anchorEl={balRef.current}/>}
          </Box_1.default>

          {/* Accounts List */}
          <div className={(0, classnames_1.default)(classes.accountDrawerContent, props.dimAccountList ? 'dim' : '')}>
            {drawerState.drawerOpen &&
            <AccountList_1.default dimAccountList={props.dimAccountList} onSelect={handleAccountNodeSelect} selectedNodeId={drawerState.selectedAccountNodeId} handleAddInstitutionLogin={handleAddInstitutionLogin} prefix={props.prefix} showColors={showColors} balanceType={balanceType} omitCents={!accountBarShowCents}/>}
          </div>
        </div>
      </div>
    </>);
};
exports.default = AccountDrawer;
